import { API_URL } from '../constants';

export const getBrands = async (token: string): Promise<any> => {
  return fetch(`${API_URL}/brands`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
